import React from "react";
import { IconX } from "@tabler/icons-react";
import ExperianSmall from "_assets/logos/experian_small.svg";
import "./Header.scss";

function Header(props) {
  const { report, view } = props;
  const primaryName =
    report?.consumerIdentity?.name?.find((n) => n.type === "N") ||
    report?.consumerIdentity?.name?.[0];
  const pdfUrl = report?.pdfUrl;
  return (
    <div className="header">
      <img src={ExperianSmall} alt="Experian" />
      <div className="report-details">
        <h2>
          {view === "applicant" ? "Primary Applicant" : "Co-Applicant"} Credit
          Report
        </h2>
        <p>
          {primaryName?.surname}, {primaryName?.firstName}{" "}
          {primaryName?.middleName || ""}
          {pdfUrl ? (
            <span>
              {" "}
              -{" "}
              <a
                className="doc-download"
                href={pdfUrl}
                target="_blank"
                rel="noreferrer"
              >
                Download Report
              </a>
            </span>
          ) : (
            ""
          )}
        </p>
      </div>
      <div className="close-drawer" onClick={props.close}>
        <IconX />
      </div>
    </div>
  );
}

export default Header;
